import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import PocTabs from '../../Components/PocTabs/PocTabs';
import { getTabs } from '../../Components/PocTabs/Utils/Context';
import { getUpcomingMatchesLayoutKey } from '../../../shared/components/react/FeaturedMatchesWidget/utils';
import { getContextIdFromLocation } from '../../Utils/NavigationAdapter';
import { GENERIC_SPORTS_COMPETITIONS } from './constants';

const FeaturedMatchesWidget = loadable(
    () => import(/* webpackChunkName: "featured-matches-widget" */ '../../../shared/components/react/FeaturedMatchesWidget/FeaturedMatchesWidget')
);

class Events extends React.Component {
    render () {
        const {
            sportSlug,
            categorySlug,
            tournamentSlug,
        } = this.props.match.params;
        const gtmAttribute = sportSlug + GENERIC_SPORTS_COMPETITIONS;

        const [
            localizedSportSlug = sportSlug,
            localizedCategorySlug = categorySlug,
            localizedTournamentSlug = tournamentSlug,
        ] = this.props.location.state.context.originalUrl;

        const tournamentId = getContextIdFromLocation(this.props.location);

        const fragmentKey = `${sportSlug}:${categorySlug}:${tournamentSlug}`;

        const featuredMatchesWidgetProps = {
            layout: getUpcomingMatchesLayoutKey(),
            sport: sportSlug,
            category: categorySlug,
            tournament: tournamentSlug,
            localizedSport: localizedSportSlug,
            tournamentId,
            source: sportSlug,
            isCompetition: true,
        };

        return (
            <React.Fragment key={fragmentKey}>
                <PocTabs
                    tabs={getTabs(sportSlug, localizedSportSlug, {
                        categorySlug: localizedCategorySlug,
                        tournamentSlug: localizedTournamentSlug,
                        tournamentId,
                    })}
                    gtmAttribute={gtmAttribute}
                />
                <FeaturedMatchesWidget {...featuredMatchesWidgetProps} />
            </React.Fragment>
        );
    }
}

Events.propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
};

export default Events;
